// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3Gxah","header":"PatientBlock_header__3JPVf","label":"PatientBlock_label__2zT4Y","option":"PatientBlock_option__13kKA"};